const editAttrs = [
  'logoPath',
  'lovedNonprofitIds',
  'volEventIds',
  'campaignIds',
  'employeesCanView',
  'linkCanView',
  'showSectionMatch',
  'showSectionVolunteer',
  'showSectionGrant',
  'showSectionGift',
  'showCustomerGifts',
  'showEmployeeGifts',
  'missionText',
  'programDetailsText',
  'hasSocialFeed',
];

export {
  editAttrs,
};

export default {
  editAttrs,
};
